export default class Actions {
    static OBTER_CHECKLIST = 'OBTER_CHECKLIST';
    static SALVAR_ETAPA_CHECKLIST = 'SALVAR_ETAPA_CHECKLIST';
    static FINALIZAR_CHECKLIST = 'FINALIZAR_CHECKLIST';
    static SALVAR_AVARIAS = 'SALVAR_AVARIAS';
    static SALVAR_FOTOS = 'SALVAR_FOTOS';
    static EXCLUIR_FOTO = 'EXCLUIR_FOTO';
    static SALVAR_TIPO_VEICULO = 'SALVAR_TIPO_VEICULO';
    static ENVIAR_EMAIL_PDF = 'ENVIAR_EMAIL_PDF';

    static formatarRespostasEtapa = (respostas) => {
        return Object.entries(respostas).reduce((acc, [key, componente]) => {
            acc[key] = componente.possuiSubcomponentes
                ? {
                    chave: componente.chave,
                    opcoes: Actions.formatarSubcomponentes(componente.opcoes),
                    respostas: true,
                }
                : {
                    chave: componente.chave,
                    respostas: componente.respostas,
                };
            return acc;
        }, {});
    };

    static formatarRespostasFinalizacao = (componentes) => {
        return Object.entries(componentes).reduce((acc, [etapa, componentesEtapa]) => {
			acc[etapa] = {
				etapa,
				componentes: Actions.formatarComponentes(componentesEtapa),
			};
			return acc;
		}, {});
    }

    static obterEtapaRespondida = (etapas, etapaAtual) => {
        let etapaRespondida = { idEtapa: etapaAtual, idChecklistModuloEtapaResposta: '' };
        if(Object.keys(etapas).length > 0) {
            etapaRespondida = etapas.etapasRespondidas.find(e => parseInt(e.idEtapa) === parseInt(etapaAtual)) || etapaRespondida;
        }

        return etapaRespondida;
    }

    static formatarComponentes = (componentesEtapa) => {
        return Object.entries(componentesEtapa).reduce((acc, [key, componente]) => {
            acc[key] = componente.possuiSubcomponentes
                ? {
                    chave: componente.chave,
                    opcoes: Actions.formatarSubcomponentes(componente.opcoes),
                    respostas: true,
                }
                : {
                    chave: componente.chave,
                    respostas: componente.respostas,
                };
            return acc;
        }, {});
    };

    static formatarSubcomponentes = (opcoes) => {
        return Object.entries(opcoes).reduce((acc, [subkey, subcomponente]) => {
            acc[subkey] = {
                chave: subcomponente.tipoComponente,
                respostas: subcomponente.respostas,
            };
            return acc;
        }, {});
    };
}
